export default __webpack_public_path__ + "static/ShareSection3_us-c729394294e3ef84937dda2e25105a2c.png";